import { MOCK_ATTORNEYS, MOCK_EXPERTS } from '~/shared/fixtures';
// TODO(backend): Replace with API or store lookup; currently uses mock attorneys/experts for display.
import { UserRole, type User } from '~/shared/types';

/** TODO(backend): Replace with API or store lookup; currently uses mock attorneys/experts for display. */
export function getUserById(id: User['id']): User {
  const user = [...MOCK_ATTORNEYS, ...MOCK_EXPERTS].find((u) => u.id === id);
  return (
    user ?? {
      id: '',
      name: 'Unknown',
      role: UserRole.ATTORNEY,
      email: '',
      avatarUrl: undefined,
    }
  );
}
